import React, { useState } from "react";
import { BlockTitle, createNotification, CustomButton, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { BackOfficeService } from "../../../../api";
import { useApi } from "../../../../common/hooks";
import { downloadFile } from "../../../../common/utils";
import styles from "./DSICompany.module.css";
import { DSICompanyUpdateSidePanel, DSICompanyBuCreationDialog, DSICompanyTable } from "./components";

export default function DSICompany({
	activeUsersInCompany = [],
	companies = [],
	onCreateBu,
	onCreateCompany,
	onSelectCompany,
	onUpdateCompany,
}) {
	const [selectedCompany, setSelectedCompany] = useState(null);
	const [openCreationDialog, setOpenCreationDialog] = useState(false);
	const { call: importTemplateThematicsFromCompany } = useApi(BackOfficeService.importTemplateThematicsFromCompany);
	const { call: exportTemplateThematicsFromCompany } = useApi(BackOfficeService.exportTemplateThematicsFromCompany);

	const handleCreateCompany = (name) => {
		onCreateCompany({ name, shortName: name });
	};
	const handleCreateBu = (name, companyId, adminId) => {
		onCreateBu({ name, shortName: name, companyId, adminId });
	};
	const handleSelectCompany = (company) => {
		if (selectedCompany && selectedCompany.id === company.id) {
			setSelectedCompany(null);
		} else {
			setSelectedCompany(company);
		}
	};
	const handleImportTemplates = (event) => {
		const targetFiles = event.target.files;
		const files = Object.values(targetFiles);
		if (selectedCompany?.id && files.length > 0) {
			importTemplateThematicsFromCompany({ companyId: selectedCompany?.id }, { file: files[0] })
				.then(() =>
					createNotification({
						type: "success",
						message: translate("dsi.dsi-company.category-templating.import.success-notification"),
					})
				)
				.catch(console.error);
		}
	};
	const handleExportTemplates = () => {
		if (selectedCompany?.id) {
			exportTemplateThematicsFromCompany({ companyId: selectedCompany?.id })
				.then(({ data, filename }) => {
					downloadFile({ data, filename, filetype: "json" });
					createNotification({
						type: "success",
						message: translate("dsi.dsi-company.category-templating.download.success-notification"),
					});
				})
				.catch(console.error);
		}
	};
	const handleOpenCreationDialog = () => {
		setOpenCreationDialog(true);
	};
	const handleCloseCreationDialog = () => {
		setOpenCreationDialog(false);
	};
	return (
		<div className={styles.container}>
			<div className={styles.leftContainer} translate="no">
				<BlockTitle className={styles.blockTitle}>
					<span>{translate("dsi.dsi-company.title")}</span>
					<CustomButton
						size="sm"
						startIcon={icon.faPlus}
						variant="contained"
						onClick={handleOpenCreationDialog}
					>
						{translate("dsi.dsi-company.company.create")}
					</CustomButton>
				</BlockTitle>
				<div className={styles.companyTable}>
					<DSICompanyTable
						activeUsersInCompany={activeUsersInCompany}
						companies={companies}
						selectedCompany={selectedCompany}
						onCreateBu={handleCreateBu}
						onSelectCompany={onSelectCompany}
						onSelectRow={handleSelectCompany}
					/>
				</div>
			</div>
			{selectedCompany && (
				<div className={styles.rightContainer} translate="no">
					<BlockTitle autoTranslate="no" className={styles.blockTitle}>
						{translate("dsi.dsi-company.company.update", { companyName: selectedCompany?.companyName })}
					</BlockTitle>
					<DSICompanyUpdateSidePanel
						selectedCompany={selectedCompany}
						onExportTemplates={handleExportTemplates}
						onImportTemplates={handleImportTemplates}
						onUpdateCompany={onUpdateCompany}
					/>
				</div>
			)}
			<DSICompanyBuCreationDialog
				open={openCreationDialog}
				onClose={handleCloseCreationDialog}
				onCreate={handleCreateCompany}
			/>
		</div>
	);
}
